import React from "react";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { Container } from "@/pages/_shared";

export default function NotFoundPage() {
  return (
    <Container className="py-14">
      <div className="rounded-3xl border border-border/60 bg-background/70 p-8">
        <div className="text-lg font-extrabold">Page not found</div>
        <p className="mt-2 text-sm text-muted-foreground">Go back to the home page.</p>
        <Button asChild className="mt-4">
          <Link to="/">Go Home</Link>
        </Button>
      </div>
    </Container>
  );
}
